import FixedContainer from '@components/containers/FixedContainer'
import MinimalistHeader from '@components/headers/MinimalistHeader'
import OVRNavigator from '@components/navigators/OVRNavigator'
import styled from 'styled-components'
import { useModuleContext } from '../contexts/module'
import { useRouter } from 'next/router'

const Navigation = () => {
  const { state: { labels, artworkInformation, roomsInformation } } = useModuleContext()
  const router = useRouter()
  const {
    onlineShowName,
    onlineMobileShowName
  } = artworkInformation || {}

  const {
    positionAsNormalNumber,
    numberOfArtworksInRoom,
    previousArtworkLink,
    nextArtworkLink,
    backLink
    // nextArtworkImage,
    // previousArtworkImage
  } = roomsInformation || {}
  const isComingFromOVRRoom = router?.query?.comingFromOVRRoom === 'true'

  return (
    <FixedContainer className='no-margin-top'>
      <MinimalistHeader
        rightSideText={onlineShowName}
        mobileTitle={onlineMobileShowName}
        altTextLabels={labels?.AltTags}
      />
      {/* @ts-ignore */}
      <OVRNavigator
        leftSideContentVisible={!!backLink}
        rightSideCenterContent={
          <ArtworksInRoomContainer className='mt-2'>
            <ArtworksInRoomLabel bold className='header-uppercase-2'>{positionAsNormalNumber}</ArtworksInRoomLabel>
            <ArtworksInRoomLabel bold className='header-uppercase-2 px-2'>/</ArtworksInRoomLabel>
            <ArtworksInRoomLabel className='header-uppercase-2'>{numberOfArtworksInRoom}</ArtworksInRoomLabel>
          </ArtworksInRoomContainer>
        }
        rightSideLeftText={labels?.ShowRoomArtwork?.artworksHeaderLabel}
        nextJSLinkInLeftSideArrow={backLink ? backLink() : ''}
        nextJSLinkInRightSideLeftArrow={previousArtworkLink}
        nextJSLinkInRightSideRightArrow={nextArtworkLink}
        rightSideContentVisible={numberOfArtworksInRoom > 1 && isComingFromOVRRoom}
        leftSideIcon='close'
        a11yData={{
          previousPage: `${labels?.AltTags?.generalViewArtwork} ${previousArtworkLink?.title || ''}`,
          nextPage: `${labels?.AltTags?.generalViewArtwork} ${nextArtworkLink?.title || ''}`
        }}
      />
    </FixedContainer>)
}

const ArtworksInRoomContainer = styled.div<any>`
  display: flex;
`

const ArtworksInRoomLabel = styled.h1<any>`
  ${({
  bold
}) => (!bold ? 'color: var(--bs-mch-gray-400) !important;' : '')}
`

export default Navigation